import * as API from "../config.json";

const method = {
    DELETE: "DELETE",
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
};

export const endpointTypes = {
    ADMIN: "admin",
    FORMLAYOUT: "formlayout",
    DRAFTWARRANTY: "draftWarranty",
    SUBMITTEDWARRANTY: "submittedWarranty",
    FETCH_REVIEW_AND_PAY_DETAILS: "reviewAndPay",
    THANK_YOU: "thankYou",
    HANDLE_TEMPLATE_ACTIONS: "templates",
    OPERATIONAL_REPORT: "operationalReport",
    SUPER_ADMIN: "superAdmin",
    PROPERTY_MANAGER: "propertyManager",
    MY_CART: "myCart",
    WARRANTY_VARIANCE: "warrantyVariance"
};

const reportUrl = {
    monthEndReport: {
        url: "Warranty/GetWarrantiesReport",
        method: "POST",
    },
    warrantiesMonthlyReport: {
        url: "Warranty/WarrantiesMonthlyReport",
        method: "POST",
    },
    TemplateCountByContractorReport: {
        url: "Warranty/TemplateCountByContractorReport",
        method: "GET",
    },
};

const endpoint = {
    admin: {
        key: endpointTypes.ADMIN,
        endpoints: {
            getUserData: () => ({
                url: API["CONFIG"].baseUrl + `Contractor/GetUserProfile`,
                method: method.GET,
                key: endpointTypes.ADMIN,
            }),
            getSearchData: (searchParam) => ({
                // url: API["CONFIG"].baseUrl + `Contractor/Search/${searchParam}`,
                url:
                    API["CONFIG"].baseUrl +
                    `Contractor/azuresearch/${searchParam.searchItem}?offset=${searchParam.offSet}&pageSize=${
                        searchParam.pageSize
                    }${searchParam.sortBy ? "&sortBy=" + searchParam.sortBy : ""}${
                        searchParam.sortBy ? "&sortOrder=" + searchParam.sort : ""
                    }`,
                method: method.GET,
                key: endpointTypes.ADMIN,
            }),
            getContractorData: (contractorObj) => ({
                url: API["CONFIG"].baseUrl + `Contractor/${contractorObj.customerId}`,
                method: method.GET,
                key: endpointTypes.ADMIN,
            }),
            // getSubmittedWarrantyData: (warrantyId) => ({
            //     url: API["CONFIG"].baseUrl + `Warranty/Submitted/${warrantyId}/FormLayout`,
            //     method: method.GET,
            //     key: endpointTypes.ADMIN,
            // }),
            getSubmittedWarrantyData: (warrantyNumber) => ({
                url: API["CONFIG"].baseUrl + `Warranty/Submitted/${warrantyNumber}/GetSubmittedWarrantyByWarrantyNumber`,
                method: method.GET,
                key: endpointTypes.ADMIN,
            }),
            deleteSubmittedWarranty: (warrantyId) => ({
                url: API["CONFIG"].baseUrl + `Warranty/CancelWarranty/${warrantyId}`,
                method: method.DELETE,
                key: endpointTypes.ADMIN,
            }),
            deleteSubmittedShoppingCart: (shoppingCartId) => ({
                url: API["CONFIG"].baseUrl + `Warranty/CancelShoppingCart/${shoppingCartId}`,
                method: method.DELETE,
                key: endpointTypes.ADMIN,
            }),
        },
    },
    draftWarranty: {
        key: endpointTypes.DRAFTWARRANTY,
        endpoints: {
            getDraftForms: () => ({
                url: API["CONFIG"].baseUrl + `Warranty`,
                method: method.GET,
                key: endpointTypes.DRAFTWARRANTY,
            }),
            deleteDraftForm: (id) => ({
                url: API["CONFIG"].baseUrl + `Warranty/${id}`,
                method: method.DELETE,
                key: endpointTypes.DRAFTWARRANTY,
            }),
        },
    },
    submittedWarranty: {
        key: endpointTypes.SUBMITTEDWARRANTY,
        endpoints: {
            getSubmittedForms: (filters) => ({
                url: API["CONFIG"].baseUrl + `Warranty/GetSubmittedWarranties`,
                method: method.POST,
                key: endpointTypes.SUBMITTEDWARRANTY,
                data: JSON.stringify(filters)
            }),
            getStateProvinceList: (countryId) => ({
                url: API["CONFIG"].baseUrl + `Warranty/GetStateOrProvinceList?countryCode=`,
                method: method.GET,
                key: endpointTypes.SUBMITTEDWARRANTY,
            })
        }
    },
    formlayout: {
        key: endpointTypes.FORMLAYOUT,
        endpoints: {
            getFormLayout: (id) => ({
                url: API["CONFIG"].baseUrl + `FormLayout/${id}`,
                method: method.GET,
                key: endpointTypes.FORMLAYOUT,
            }),
            getSavedFormLayout: (id) => ({
                url: API["CONFIG"].baseUrl + `Warranty/${id}/FormLayout`,
                method: method.GET,
                key: endpointTypes.FORMLAYOUT,
            }),
            getSavedFormData: (id) => ({
                url: API["CONFIG"].baseUrl + `Warranty/${id}/FormData`,
                method: method.GET,
                key: endpointTypes.FORMLAYOUT,
            }),
            getSavedFormDataWithWarrantyNumber: (warrantyNumber) => ({
                url: API["CONFIG"].baseUrl + `Warranty/${warrantyNumber}/SearchWarrantyData`,
                method: method.GET,
                key: endpointTypes.FORMLAYOUT,
            }),
            saveDraftForm: (formData) => ({
                url: API["CONFIG"].baseUrl + `Warranty`,
                method: method.POST,
                data: JSON.stringify(formData),
                key: endpointTypes.DRAFTWARRANTY,
            }),
            updateDraftForm: (formData) => ({
                url: API["CONFIG"].baseUrl + `Warranty`,
                method: method.PUT,
                data: JSON.stringify(formData),
                key: endpointTypes.DRAFTWARRANTY,
            }),
            updateSubmittedWarranty: (formData) => ({
                url: API["CONFIG"].baseUrl + `Warranty/ReSubmitWarranty`,
                method: method.POST,
                data: JSON.stringify(formData),
                key: endpointTypes.FORMLAYOUT,
            }),
            // TODO - Replace actual API["CONFIG"] endpoint
            getErrorResponse: (formData) => ({
                url: API["CONFIG"].baseUrl + `FormLayout/ValidateFormData/` + 1,
                method: method.POST,
                key: endpointTypes.FORMLAYOUT,
                data: JSON.stringify(formData),
            }),
            checkEditable: (requestPayload) => ({
                // url: "http://192.168.0.101.:8080" + `/Warranty/${warrantyId}/IsPriceChanged`,
                url: API["CONFIG"].baseUrl + `Warranty/${requestPayload.warrantyId}/IsPriceChanged`,
                method: method.POST,
                key: endpointTypes.FORMLAYOUT,
                data: requestPayload.data,
            }),
            GetContractorFormSettings: () => ({
                url: API["CONFIG"].baseUrl + `Contractor/GetContractorFormSettings`,
                // url: `https://residentialwarrantyint.gaf.com/api/Contractor/GetWarrantyTypes`,
                method: method.GET,
                key: endpointTypes.FORMLAYOUT,
            }),
            getFormLayoutDetails: () => ({
                url: API["CONFIG"].baseUrl + `FormLayout/GetFormLayoutId/Residential%20Warranty`,
                method: method.GET,
                key: endpointTypes.FORMLAYOUT,
            }),
        },
    },
    // this will be used to create aunifrom URL which will be used in saga fetchreview&pay fun
    reviewAndPay: {
        key: endpointTypes.FETCH_REVIEW_AND_PAY_DETAILS,
        endpoints: {
            getReviewAndPay: (payload) => ({
                url: API["CONFIG"].baseUrl + "Warranty/ReviewFormData",
                method: method.POST,
                key: endpointTypes.FETCH_REVIEW_AND_PAY_DETAILS,
                data: JSON.stringify(payload),
            }),
        },
    },
    thankYou: {
        endpoints: {
            key: endpointTypes.THANK_YOU,
            beginTransaction: (payload) => ({
                url: `${API["CONFIG"].baseUrl}Payment/BeginTransaction`,
                method: method.POST,
                data: JSON.stringify(payload),
                key: endpointTypes.THANK_YOU,
            }),
            validateTransaction: (payload) => ({
                url: `${API["CONFIG"].baseUrl}Payment/ProcessTransaction`,
                method: method.POST,
                data: JSON.stringify(payload),
                key: endpointTypes.THANK_YOU,
            }),
            generateFullPDF: (warrantyId) => ({
                url: `${API["CONFIG"].baseUrl}Warranty/GenerateReport/${warrantyId}`,
                method: method.GET,
                key: endpointTypes.THANK_YOU,
                responseType: "blob",
            }),
            reviewAndPay: {
                key: endpointTypes.FETCH_REVIEW_AND_PAY_DETAILS,
                endpoints: {
                    getReviewAndPay: (id) => ({
                        url: API["CONFIG"].baseUrl + `Warranty/${id}/Review`,
                        method: method.GET,
                        key: endpointTypes.FETCH_REVIEW_AND_PAY_DETAILS,
                    }),
                },
            },
            downloadWarrantySummaryPdf :(warrantyNumber) => ({
                url: API["CONFIG"].baseUrl + `Warranty/DownloadWarrantySummaryPDF/${warrantyNumber}`,
                method: method.GET,
                key: endpointTypes.THANK_YOU,
                responseType: "blob",
            }),
            checkGeneratable: (warrantyId) => ({
                url: `${API["CONFIG"].baseUrl}Warranty/CanGenerateReport/${warrantyId}`,
                method: method.GET,
                key: endpointTypes.THANK_YOU,
            }),
            checkAutoGenerate: (warrantyId) => ({
                url: `${API["CONFIG"].baseUrl}Warranty/AutoGenerateReport/${warrantyId}`,
                method: method.GET,
                key: endpointTypes.THANK_YOU,
            }),
            downloadAllWarranties: (shoppingCartId) => ({
                url: `${API["CONFIG"].baseUrl}Warranty/DownloadShoppingCartWarrantyZipFile?ShoppingCartId=${shoppingCartId}`,
                method: method.GET,
                key: endpointTypes.THANK_YOU,
                responseType: "blob",
            })
        },
    },
    templates: {
        key: endpointTypes.HANDLE_TEMPLATE_ACTIONS,
        endpoints: {
            getTemplateById: (id) => ({
                url: API["CONFIG"].baseUrl + `Template/TemplateId?Id=${id}`,
                method: method.GET,
                key: endpointTypes.HANDLE_TEMPLATE_ACTIONS,
            }),
            getAllTemplates: () => ({
                url: API["CONFIG"].baseUrl + `Template`,
                method: method.GET,
                key: endpointTypes.HANDLE_TEMPLATE_ACTIONS,
            }),
            saveTemplate: (formData) => ({
                url: API["CONFIG"].baseUrl + `Template`,
                method: method.POST,
                data: JSON.stringify(formData),
                key: endpointTypes.HANDLE_TEMPLATE_ACTIONS,
            }),
            deleteTemplates: (ids) => ({
                url: API["CONFIG"].baseUrl + `Template/${ids}`,
                method: method.DELETE,
                key: endpointTypes.HANDLE_TEMPLATE_ACTIONS,
            }),
        },
    },
    propertyManager: {
        key: endpointTypes.PROPERTY_MANAGER,
        endpoints: {
            getPropertyManagers: () => ({
                url: API.CDN_PROPERTY_MANAGER_JSON,
                method: method.GET,
                key: endpointTypes.PROPERTY_MANAGER,
                disableHeader: true,
            }),
        }
    },
    operationalReport: {
        key: endpointTypes.OPERATIONAL_REPORT,
        endpoints: {
            getOperationalReport: (postData, reportType) => ({
                url: API["CONFIG"].baseUrl + `${reportUrl[reportType]["url"]}`,
                method: reportUrl[reportType]["method"],
                data: reportUrl[reportType]["method"] === method.POST ? JSON.stringify(postData) : "",
                key: endpointTypes.OPERATIONAL_REPORT,
            }),
        }
    },
    myCart: {
        key: endpointTypes.MY_CART,
        endpoints: {
            getMyCartItems: (id) => ({
                url: API["CONFIG"].baseUrl + `ShoppingCart/GetShoppingCartItems?ShoppingCartId=${id}`,
                method: method.GET,
                key: endpointTypes.MY_CART,
            }),
            getMySubmittedCartItems: (id) => ({
                url: API["CONFIG"].baseUrl + `ShoppingCart/GetSubmittedShoppingCartItems?ShoppingCartId=${id}`,
                method: method.GET,
                key: endpointTypes.MY_CART,
            }),
            getActiveShoppingCart: () => ({
                url: API["CONFIG"].baseUrl + `ShoppingCart/GetActiveShoppingCart`,
                method: method.GET,
                key: endpointTypes.MY_CART,
            }),
            createShoppingCart: (postData = {}) => ({
                url: API["CONFIG"].baseUrl + `ShoppingCart/CreateShoppingCart`,
                method: method.POST,
                data: JSON.stringify(postData),
                key: endpointTypes.MY_CART,
            }),
            addCartItem: (postData = {}) => ({
                url: API["CONFIG"].baseUrl + `ShoppingCart/AddShoppingCartItem`,
                method: method.POST,
                data: JSON.stringify(postData),
                key: endpointTypes.MY_CART,
            }),
            deleteCartItem: (postData = {}) => ({
                url: API["CONFIG"].baseUrl + `ShoppingCart/DeleteShoppingCartItem`,
                method: method.DELETE,
                data: JSON.stringify(postData),
                key: endpointTypes.MY_CART,
            }),
            beginTransaction: (postData = {}) => ({
                url: API["CONFIG"].baseUrl + `Payment/BeginTransaction`,
                method: method.POST,
                data: JSON.stringify(postData),
                key: endpointTypes.MY_CART,
            }),
            reSubmitShoppingCart: (postData = {}) => ({
                url: API["CONFIG"].baseUrl + `Payment/BeginTransaction`,
                method: method.POST,
                data: JSON.stringify(postData),
                key: endpointTypes.MY_CART,
            }),
        }
    },
    superAdmin: {
        key: endpointTypes.SUPER_ADMIN,
        endpoints: {
            refreshRedisCache: () => ({
                url: API["CONFIG"].baseUrl + "Warranty/RemoveAllCacheKeys",
                method: method.POST,
                key: endpointTypes.SUPER_ADMIN,
            }),
            refreshActionScope: () => ({
                url: API["CONFIG"].baseUrl + "Warranty/RefreshActionScopesCacheKey",
                method: method.POST,
                key: endpointTypes.SUPER_ADMIN,
            }),
            createFormlayoutJSON: (contractorId) => ({
                url: API["CONFIG"].baseUrl + `FormLayout/CreateFormLayoutJsonInAzure/1/${contractorId}`,
                method: method.POST,
                key: endpointTypes.SUPER_ADMIN,
            }),
            refreshPropertyManagerJson: () => ({
                url: API["CONFIG"].baseUrl + "Warranty/CreatePropertyManagerJsonInAzure",
                method: method.POST,
                key: endpointTypes.SUPER_ADMIN,
            }),
            apiDeepHealthCheck: () => ({
            url: API["CONFIG"].baseUrl + "HealthCheck/DeepHealthCheck",
            method: method.GET,
            key: endpointTypes.SUPER_ADMIN,
        }),
        }
    },
    warrantyVariance: {
        key: endpointTypes.WARRANTY_VARIANCE,
        endpoints: {
            saveWarrantyVariance: (warrantyId, payload) => ({
                url: `${API["CONFIG"].baseUrl}Warranty/SaveWarrantyVarianceWaiver/${warrantyId}`,
                method: method.PUT,
                data: JSON.stringify(payload),
                key: endpointTypes.WARRANTY_VARIANCE,
            })
        }
    }
};

export default endpoint;
